export default __webpack_public_path__ + "static/media/InactiveLiveChannel.77040b10.svg";